import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    summaryItemListItemRoot: {
      padding: theme.spacing(1, 2),
    },
  };
};
